import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';

const global = window;

inputs.types.tel = function (data, name, niceName, type, input, parent, inputWindow) {
    const iti = intlTelInput(input.get(0), {
        countrySelectorMode: "OFF",
        separateDialCode: false,
        allowNumberExtensions: true,
        allowPhonewords: true,
        countryNameLocale: "fr",
        countrySearch: false,
        placeholderNumberPolicy: "OFF",
        placeholderNumberType: "FIXED_LINE",
        strictMode: true,
        initialCountry: (data.initialCountry || 'ca').toLowerCase(),
        ...(data.itiOptions || {}),
    });

    const toggleIcon = function () {
        const val = input.val();
        const isEmpty = !val || val.trim() === '';
        input.closest('.iti').toggleClass('iti--empty', isEmpty);
    };

    input.on('input change keyup blur countrychange', toggleIcon);
    toggleIcon();

    input.data('iti', iti);
    data.iti = iti;

    return data;
};

